module.exports = __webpack_public_path__ + "media/images/ticket/navi_leisure-192f2180eed9da6abc0c95476fddf784.png";